import { connect } from 'react-redux'

import HouseholdHealthTab from './HouseholdHealthTab'
import redux  from '../../../../../redux'
const { apiEndpoints, userStore } = redux
const callAPI = userStore.callAPI
const GET_HOUSEHOLD_HEALTH_ROLLUP = apiEndpoints.GET_HOUSEHOLD_HEALTH_ROLLUP;

const mapStateToProps = (state: any) =>
{
  return{
    householdsHealthRollup: state.system.householdsHealthRollup,
    householdsHealthRollupError: state.system.householdsHealthRollup,
    isGettingHouseholdsHealth: state.system.isGettingHouseholdsHealth,
  }
}

const mapDispatchToProps = (dispatch: any) =>
{
  return{
    getRollup: () => dispatch(callAPI(GET_HOUSEHOLD_HEALTH_ROLLUP())),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HouseholdHealthTab)